import MicroFrontend from '../MicroFrontend'
import {Header} from '../shared/header/Header'
import {Footer} from '../shared/footer/Footer'
import {SideBar} from "../shared/header/SideBar";
import "./scrollable.css"

const verticalNavStyle = {
    height: '100vh'
}

export function Simulation({history, userPermissions}) {
    const {REACT_APP_SIMULATION_HOST: simulationHost} = process.env
    return (
        <div>
            <div className="eds-flex" style={verticalNavStyle}>
                <div>
                    <SideBar userPermissions={userPermissions}/>
                </div>
                <div className="eds-flex--grow-1">
                    <Header isDark={true} userPermissions={userPermissions}/>
                    <div className="scrollable">
                        <MicroFrontend
                            history={history}
                            host={simulationHost}
                            microFrontendUiName="Simulation"
                            permissions={userPermissions}/>
                        <Footer/>
                    </div>
                </div>
            </div>
        </div>
    )
}
